import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { zIndexLevels } from "../../internalConstants";
import { colors, borderRadius, fonts, grid } from "../../tokens";
import * as controls from "../../tokens/controls";
var normal = controls.normal,
  hover = controls.hover,
  disabled = controls.disabled,
  focus = controls.focus,
  active = controls.active,
  invalid = controls.invalid;
var getControlBorderColor = function getControlBorderColor(isDisabled, isFocused, error) {
  if (isDisabled) return disabled.borderColor;
  if (isFocused) return focus.borderColor;
  if (error) return invalid.borderColor;
  return normal.borderColor;
};
export default {
  option: function option(provided, state) {
    return _objectSpread(_objectSpread({
      display: "flex",
      alignItems: "center"
    }, fonts["body-1"]), {}, {
      color: colors.gray[10],
      backgroundColor: state.isFocused ? colors.blue[50] : colors.white,
      padding: "4px",
      paddingRight: grid.large,
      "&:hover": {
        backgroundColor: colors.blue[50],
        cursor: "pointer"
      }
    });
  },
  container: function container() {
    return {
      padding: "var(--CDS-spacing-xxxs)",
      margin: "calc(var(--CDS-spacing-xxxs) * -1)"
    };
  },
  control: function control(provided, state) {
    return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, normal), {}, {
      display: "flex",
      alignItems: "center",
      height: 44,
      boxSizing: "border-box",
      flexWrap: "nowrap",
      justifyContent: "space-between",
      border: normal.border,
      borderColor: getControlBorderColor(state.isDisabled, state.isFocused, state.selectProps.errorMessage),
      "& div:last-child svg": {
        fill: state.selectProps.errorMessage ? "var(--CDS-color-semantic-feedback-critical-default)" : "var(--CDS-color-semantic-surface-foreground-subtle)"
      }
    }, !state.selectProps.isDisabled && {
      "&:active": {
        borderColor: "var(--CDS-color-semantic-actions-default)",
        "& div:last-child svg": {
          fill: "var(--CDS-color-semantic-actions-default)"
        }
      },
      "&:hover": {
        "& div:last-child svg": {
          fill: "var(--CDS-color-semantic-surface-foreground-default)"
        },
        borderColor: hover.borderColor
      }
    }), state.selectProps.menuIsOpen && _objectSpread({}, active)), state.isDisabled && _objectSpread({}, disabled)), {}, {
      "&:focus-within": state.isFocused ? _objectSpread({}, focus) : ""
    });
  },
  valueContainer: function valueContainer() {
    return {
      display: "flex",
      overflow: "hidden",
      padding: "var(--CDS-spacing-xxxs) var(--CDS-spacing-xs)",
      alignItems: "center"
    };
  },
  indicatorsContainer: function indicatorsContainer() {
    return {};
  },
  indicatorContainer: function indicatorContainer() {
    return {};
  },
  singleValue: function singleValue(provided, state) {
    return {
      marginLeft: "var(--CDS-spacing-xxxs)",
      overflow: "hidden",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      boxSizing: "border-box",
      color: state.selectProps.errorMessage ? "var(--CDS-color-semantic-feedback-critical-default)" : "var(--CDS-color-semantic-surface-foreground-default)"
    };
  },
  placeholder: function placeholder(provided, state) {
    return {
      whiteSpace: "nowrap",
      marginLeft: "var(--CDS-spacing-xxxs)",
      color: state.selectProps.isDisabled ? "var(--CDS-color-semantic-surface-foreground-disabled)" : "var(--CDS-color-semantic-surface-foreground-subtle)"
    };
  },
  indicatorSeparator: function indicatorSeparator() {
    return {
      display: "none"
    };
  },
  menuPortal: function menuPortal(provided) {
    return _objectSpread(_objectSpread({}, provided), {}, {
      zIndex: zIndexLevels.selectMenu,
      width: "auto",
      minWidth: provided.width,
      maxWidth: "calc(100vw - ".concat(provided.left, "px)")
    });
  },
  menu: function menu(provided, state) {
    return _objectSpread(_objectSpread({}, provided), {}, {
      width: "auto",
      position: "static",
      borderRadius: borderRadius.small,
      overflowX: "hidden"
    }, state.placement === "top" ? {
      transform: "translateY(calc(-100% - ".concat(grid.small, "px))")
    } : {});
  },
  menuList: function menuList(provided) {
    return _objectSpread(_objectSpread({}, provided), {}, {
      overflowX: "hidden",
      textOverflow: "ellipsis"
    });
  },
  input: function input(base) {
    return _objectSpread(_objectSpread({}, base), {}, {
      margin: "0 0 0 var(--CDS-spacing-xxxs)",
      input: {
        boxShadow: "none !important",
        outline: "none !important",
        border: "none !important",
        marginBottom: "0px"
      }
    });
  }
};